import * as React from 'react';
import {
    Box,
    Step,
    Button,
    Stepper,
    StepLabel,
    Typography,
    Alert,
    CircularProgress
} from '@mui/material';
import PaxList from './StepperSteps/PaxList';
import Summary from './StepperSteps/Summary';
import { TourLeader } from './StepperSteps/TourLeader';
import { useNavigate } from 'react-router-dom';
import { PersonalPreferences } from './StepperSteps/PersonalPreferences';
import { AccommodationPreferences } from './StepperSteps/AccommodationPreferences';
import { observer } from 'mobx-react';
import store from '../store';
import { FormApi } from '../API/api';
import logo from '../assets/livetmb-logo.jpg';

const steps = [
    { label: 'הרשמה', component: <TourLeader /> },
    { label: 'פרטי נוסעים', component: <PaxList /> },
    { label: 'העדפות אישיות', component: <PersonalPreferences /> },
    { label: 'בחירת מקומות לינה ', component: <AccommodationPreferences /> },
    { label: 'סיום', component: <Summary /> },
];

const StepperPage = observer(() => {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = React.useState(0);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [submitError, setSubmitError] = React.useState('');

    React.useEffect(() => {
        store.loadPersistedData();
    }, []);

    const handleNext = async () => {
        setSubmitError('');

        if (activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            return;
        }

        setIsSubmitting(true);
        try {
            await FormApi.submitForm();
            store.resetStore();
            navigate('/ThankYou');
        } catch (error) {
            console.error('Error:', error);
            setSubmitError('לא הצלחנו לשלוח את הטופס. בדקו את החיבור ונסו שוב.');
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <main className="booking-app" dir="rtl">
            <section className="booking-hero">
                <div className="booking-hero__image" aria-hidden="true" />
                <div className="booking-hero__content">
                    <img src={logo} alt="LiveTMB" className="booking-logo" />
                    <Typography component="h1" className="booking-title">
                        טופס הכנה להזמנת לינות
                    </Typography>
                    <Typography className="booking-subtitle">
                        כל הפרטים במקום אחד כדי שנוכל לסגור עבורכם לינות בצורה מדויקת, רגועה ומסודרת.
                    </Typography>
                </div>
            </section>

            <section className="booking-workspace">
                <Box className="booking-progress">
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((step, index) => (
                            <Step key={index}>
                                <StepLabel>{step.label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>

                {submitError && (
                    <Alert severity="error" sx={{ mb: 2, direction: 'rtl', textAlign: 'right' }}>
                        {submitError}
                    </Alert>
                )}

                <Box className="booking-card">
                    {steps[activeStep].component}
                </Box>

                <Box className="booking-actions">
                    <Button
                        variant="contained"
                        disabled={
                            isSubmitting
                            || (store.tourLeader.name === undefined
                            && store.tourLeader.email === undefined
                            && store.tourLeader.phone === undefined)
                            || (activeStep === steps.length - 1 && !store.termsAccepted)
                        }
                        onClick={handleNext}
                    >
                        {isSubmitting ? <CircularProgress size={22} color="inherit" /> : activeStep === steps.length - 1 ? 'שליחת הטופס' : 'הבא'}
                    </Button>
                    <Button
                        disabled={activeStep === 0 || isSubmitting}
                        onClick={handleBack}
                        variant='outlined'
                    >
                        קודם
                    </Button>
                </Box>
            </section>
        </main>
    );
});

export default StepperPage;
